import { z } from "zod";

export const kiliProgrammingIsSuspendedOnSiteSchema = z.object({
  isSuspended: z.boolean(),
});

export type TKiliProgrammingIsSuspendedOnSite = z.infer<typeof kiliProgrammingIsSuspendedOnSiteSchema>;
